module.exports = "<ol class=\"breadcrumb\">\n      <li class=\"active breadcrumb-item\">Home</li>\n</ol>\n<ol class=\"breadcrumb\">\n      <li class=\"breadcrumb-item\">\n            <a href=\"#\">Home</a>\n      </li>\n      <li class=\"active breadcrumb-item\">Library</li>\n</ol>\n<ol class=\"breadcrumb\">\n      <li class=\"breadcrumb-item\">\n            <a href=\"#\">Home</a>\n      </li>\n      <li class=\"breadcrumb-item\">\n            <a href=\"#\">Library</a>\n      </li>\n      <li class=\"active breadcrumb-item\">Data</li>\n</ol>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Breadcrumb/Breadcrumb.html
// module id = 281
// module chunks = 0